import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AbstractOptionComponent} from '../abstract-option/abstract-option.component';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-text-option',
  imports: [
    FormsModule
  ],
  templateUrl: './text-option.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './text-option.component.scss'
})
export class TextOptionComponent extends AbstractOptionComponent {
  value: string = '';

  setData(data: any): void {
  }

  getValue(): any {
    return this.value;
  }

  setValue(value: any): void {
    this.value = value.toString();
  }
}
